import React from 'react';
import styled from 'styled-components'
import { checkPropTypes } from 'prop-types';
import CategoryIndex from '../../templates/category_index';

const ArticleTypeStyle = styled.div`
{
    // height: 22px;
    width: ${ (props) => {
        const {postType} = props
        if (postType === "live preview" || postType === "photo gallery"){
            return "150px"
        } 

        if (postType === "Sponsored"){
            console.log("Sponsored tag")
            return "85px"
        }
        return "80px;"
        
    }};
    // max-width: 150px;
    border-radius: 2px;
    background-color: ${ (props) => {
        switch(props.articleTag) {
            case "Feature":
                return "#2379f6"
                break;
            case "List":
                return "#be23f6"
                break;
            case "News":
                return "#f6a623"
                break;
            case "Review":
                return "#16a93a"
                break;
            case "Sponsored":
                return "#000000"
                break;
            default:
                return "#EB5762"
        }
    }};
    font-size: 13px;
    font-weight: 500;
    // line-height: 22px;
    color: white;
    text-align: center;
    margin-bottom: 16px;
    text-transform: uppercase;
    padding: 3px;
  }
`

export default class ArticleType extends React.Component {
    render(){
        const {articleTag} = this.props   
        
        return (
            <ArticleTypeStyle articleTag={articleTag} >
               {articleTag}
            </ArticleTypeStyle>
        )
    }
};
  
